module.exports = __webpack_public_path__ + "img/stale-while-revalidate.9bbf5aca.png";